@if (!isHidden) {
  <section class="sidenav" [@inOutAnimation]>
    <div class="sidenav-content">
      <div class="title-row-wrap">
        <span class="title"><ng-content select="[title]"></ng-content></span>
        <ng-content select="[actions]"></ng-content>
        <button mat-mini-fab class="hide-button" id="btnFabHide" color="primary" (click)="onToggleHide()"><mat-icon>chevron_left</mat-icon></button>
      </div>
      <span class="subtitle"><ng-content select="[subtitle]"></ng-content></span>
      <ng-content></ng-content>
    </div>
  </section>
}
@if (isHidden) {
  <div class="showSideNav">
    <button mat-mini-fab [@inOutAnimation] color="primary" class="show-button" id="btnFabShow" (click)="onToggleHide()"><mat-icon>chevron_right</mat-icon></button>
  </div>
}
